// extracted by mini-css-extract-plugin
export default {"navigation-bar":"navigationBar_navigation-bar__9i1Os","sections-list":"navigationBar_sections-list__0jkHx"};